import React from 'react'

const Manual_requisiciones_solicitar_una_requisicion = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Requisiciones - Solicitar una Requisición
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía proporciona un proceso paso a paso para solicitar y gestionar
    requisiciones eficazmente, garantizando que los usuarios puedan navegar
    fácilmente por el sistema de pedidos. Siguiendo estas instrucciones, podrá
    mantener niveles de inventario precisos y garantizar que las solicitudes se
    procesen eficientemente. Los pasos detallados ayudan a prevenir errores,
    facilitando una mejor comunicación entre sucursales.
     </p>
     <iframe
          src="https://scribehow.com/embed/Requisiciones__Solicitar_una_Requisicion__fX1kJlZXRvWf9pFNR5glwg?as=scrollable"
          className="scribe-iframe-general-3"
          width="100%"
          height="9400"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_requisiciones_solicitar_una_requisicion